import React, { useEffect } from 'react';

import { AudioListenButton } from '@atlassian/ai-audio';

import { useActiveContent } from '@confluence/audio/entry-points/useActiveContent.ts';
import { useAudioContentQuery } from '@confluence/audio/entry-points/useAudioContentQuery.tsx';
import { useAudioButtonWrapperActions } from '@confluence/audio/entry-points/useAudioButtonWrapperStore.tsx';
import { expValEquals } from '@confluence/feature-experiments';
import { AudioButtonSpotlight as PostOfficeAudioButtonSpotlight } from '@confluence/experiment-audio-button-changeboarding';

type AudioListenButtonWrapperProps = {
	isRovoButtonEnabled: boolean;
	contentId: string;
	contentType: string;
	spaceKey: string;
	title: string;
	isAutoOpenDisabled?: boolean;
};

export const AudioListenButtonWrapper = ({
	isRovoButtonEnabled,
	isAutoOpenDisabled,
	contentId,
	...props
}: AudioListenButtonWrapperProps) => {
	const { data } = useAudioContentQuery({ contentId });
	const activeContent = useActiveContent({ contentId, data, ...props });
	const { setActiveContent } = useAudioButtonWrapperActions();

	useEffect(() => {
		if (data?.singleContent) {
			setActiveContent(activeContent);
		} else {
			setActiveContent(null);
		}
	}, [data?.singleContent, activeContent, setActiveContent]);

	if (expValEquals('confluence_audio_v3_changeboarding', 'isEnabled', true)) {
		return (
			<>
				<PostOfficeAudioButtonSpotlight />
				<AudioListenButton
					shape={isRovoButtonEnabled ? 'default' : 'circle'}
					activeContent={activeContent}
					isAutoOpenDisabled={!data?.singleContent || !!isAutoOpenDisabled}
					source="contentWrapper"
				/>
			</>
		);
	}

	return (
		<AudioListenButton
			shape={isRovoButtonEnabled ? 'default' : 'circle'}
			activeContent={activeContent}
			isAutoOpenDisabled={!data?.singleContent || !!isAutoOpenDisabled}
			source="contentWrapper"
		/>
	);
};
